import React, {useState, useEffect} from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Axios from 'axios';

const steps = [
    {
      label: 'Step 1',
      description: ``,
    },
    {
      label: 'Step 2',
      description: '',
    },
    {
      label: 'Step 3',
      description: ``,
    }
];

const urlMapping = {
    staging: {
        html: `<script src="https://cdn.mrsziplyneweb.hosts.jhmi.edu/scripts/snippet/JHstaging.js"></script>`,
        javascript: `var script = document.createElement('script');\nscript.src = 'https://cdn.mrsziplyneweb.hosts.jhmi.edu/scripts/snippet/JHstaging.js';\ndocument.head.appendChild(script);`
    }, 
    production: {
        html: `<script src="https://cdn.mrmpzipweb01.hosts.jhmi.edu/scripts/snippet/JHprod.js"></script>`,
        javascript: `var script = document.createElement('script');\nscript.src = 'https://cdn.mrmpzipweb01.hosts.jhmi.edu/scripts/snippet/JHprod.js';\ndocument.head.appendChild(script);`
    },
    production2: {
        html: `<script src="https://cdn.mrmpzipweb02.hosts.jhmi.edu/scripts/snippet/JHprod2.js"></script>`,
        javascript: `var script = document.createElement('script');\nscript.src = 'https://cdn.mrmpzipweb02.hosts.jhmi.edu/scripts/snippet/JHprod2.js';\ndocument.head.appendChild(script);`
    }
}

const EmbedForm = () => {
    const [environment, setEnvironment] = useState('staging');
    const [textContent, setTextContent] = useState('');
    const [activeStep, setActiveStep] = React.useState(0);
    const [codeType, setCodeType] = React.useState(['html','javascript']);
    const [selectedType, setSelectedType] = React.useState('')

    const handleNext = () => {
        let nextStep = activeStep + 1;
        if (nextStep === 2) {
            if (selectedType) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            } else {
                let el = document.getElementById('Embedform__warning');
                el.textContent = 'Select the type first';
                el.style.color = "red";
                el.style.fontWeight = "bold";
                setTimeout(() => {
                    el.textContent = '';
                }, 4000);
            }
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setEnvironment('staging')
        setActiveStep(0);
        setSelectedType('')
    };


    useEffect(() => {
        AOS.init({
          duration: 2500,
        }); 
    }, []);

    useEffect(() => {
        if (activeStep === 2) {
            generateEmbedScript()
        }
    }, [activeStep])

    const apiBaseURL = {
        staging: {
            url: "https://stagingapi.mrsziplyneweb.hosts.jhmi.edu/api/v2",
            cdn: "https://cdn.mrsziplyneweb.hosts.jhmi.edu/scripts/embed"
        },
        production: {
            url: "https://api.mrmpzipweb01.hosts.jhmi.edu/api/v2",
            cdn: "https://cdn.mrmpzipweb01.hosts.jhmi.edu/scripts/embed"
        }
    }

    const handleChange = (e) => {
        setEnvironment(e.target.value);
        setTextContent('');
    }

    const generateEmbedScript = () => {
        handleNext();
        let el = document.getElementById('copy-btn');
        let script = urlMapping[environment][selectedType];
        setTextContent(script)
        el.textContent = 'Copy text';
    }

    const copyScript = () => {
        let importantTitle = document.getElementById('Embedform__important');
        let newEl = document.createElement('span');
        newEl.textContent = ' (Important)';
        newEl.setAttribute('style', 'color: red; font-weight: bold');
        importantTitle.appendChild(newEl)
        setTimeout(() => {
            importantTitle.removeChild(newEl)
        }, 3000)
        let copyText = document.getElementById("embedScript");

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText.textContent);

        let copyEl = document.getElementById('copy-btn');
        copyEl.textContent = 'Copied!'
    }

    return (
        <div id="EmbedForm">
            <div className="EmbedForm__header">
                <h2 className="EmbedForm__title">
                    Embed Script Generator
                </h2>
                <Box className="EmbedForm__stepper">
                    <Stepper activeStep={activeStep}>
                        {steps.map((step, index) => (
                        <Step key={step.label}>
                            <StepLabel
                            className="Embed__stepper_step"
                            optional={
                                index === 2 ? (
                                <Typography variant="caption">Last step</Typography>
                                ) : null
                            }
                            >
                            {step.label}
                            </StepLabel>
                            <StepContent>
                            <Typography>{step.description}</Typography>
                            <Box sx={{ mb: 2 }}>
                                <div>
                                <Button
                                    variant="contained"
                                    onClick={handleNext}
                                    sx={{ mt: 1, mr: 1 }}
                                    className="Embed__stepper_btn_next"
                                >
                                    {index === steps.length - 1 ? 'Finish' : 'Continue'}
                                </Button>
                                <Button
                                    disabled={index === 0}
                                    onClick={handleBack}
                                    sx={{ mt: 1, mr: 1 }}
                                    className="Embed__stepper_btn_back"
                                >
                                    Back
                                </Button>
                                </div>
                            </Box>
                            </StepContent>
                        </Step>
                        ))}
                    </Stepper>
                    {activeStep === steps.length && (
                        <Paper square elevation={0} sx={{ p: 3 }}>
                        <Typography>All steps completed - you&apos;re finished</Typography>
                        <Button 
                            onClick={handleReset} 
                            sx={{ mt: 1, mr: 1 }}
                            className="Embed__stepper_btn_next"
                        >
                            Reset
                        </Button>
                        </Paper>
                    )}
                </Box>
                <div className="EmbedForm__description">
                {
                    activeStep === 0 && (
                        <form className="EmbedForm__form">
                        <label style={{marginBottom: "2rem", fontWeight: "bold"}}>Please select the Ziplyne Environment for Hopkins</label>
                        <div className="Embedform__form__child_wrapper">
                            <div className="EmbedForm__form__child">
                                <input 
                                    type="radio" 
                                    name="environment" 
                                    value="staging"
                                    checked={environment === 'staging'}
                                    onChange={handleChange}
                                    className="EmbedForm__radio" 
                                />
                                <label>Staging</label>
                            </div>
                            <div className="EmbedForm__form__child">
                                <input 
                                    type="radio" 
                                    name="environment" 
                                    value="production"
                                    checked={environment === "production"}
                                    onChange={handleChange}
                                    className="EmbedForm__radio" 
                                />
                                <label>Production</label>
                            </div>
                            <div className="EmbedForm__form__child">
                                <input 
                                    type="radio" 
                                    name="environment" 
                                    value="production2"
                                    checked={environment === 'production2'}
                                    onChange={handleChange}
                                    className="EmbedForm__radio" 
                                />
                                <label>Production 2 (External Sites)</label>
                            </div>
                        </div>
                    </form>
                    )
                }
                {
                    activeStep === 1 && (
                        <>
                        <h3 id="Embedform__warning" style={{textAlign: "center"}}></h3>
                        <h3 style={{textAlign: "center"}}>Select the type of Embed Script</h3>
                        <Stack id="domains" style={{margin: "0 auto"}} spacing={2} sx={{ width: 300 }}>
                            <Autocomplete
                                // freeSolo
                                id="free-solo-2-demo"
                                disableClearable
                                options={codeType}
                                onChange={(event, newValue) => {
                                    setSelectedType(newValue);
                                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                                }}
                                value={selectedType}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Search for the type"
                                    InputProps={{
                                    ...params.InputProps,
                                    type: 'search',
                                    }}
                                />
                                )}
                            />
                        </Stack>
                        </>
                    )
                }
                {
                    (activeStep === 2 || activeStep === 3) && (
                        <div className="EmbedForm__generator">
                            <h3 id="Embedform__important">Copy the script to clipboard and inject it to your application</h3>
                            <div
                                id="embedScript" 
                                className="EmbedForm__textarea"
                            >{textContent}</div> 
                            <div>
                                <button onClick={copyScript} id="copy-btn">Copy script</button>
                            </div>
                        </div>
                    )
                }
                </div>
            </div>
        </div>
    )
}

export default EmbedForm;